@if (!colorMenuOpen()) {
  <div class="section-settings">
    <ng-content></ng-content>

    <h3 class="menu-list-title">SECTION</h3>

    @if (section.object !== 'text') {
      <div class="section-setting-row">
        <div class="setting-name">Width</div>
        <div class="setting-value">
          @for (width of widths; track width) {
            <button
              appButton
              [name]="'section_width'"
              [analyticsExtra]="{ width: width.value }"
              location="common-section-settings"
              [color]="
                (section.width ?? theme.section.width) === width.value ? 'simple-primary-opacity' : 'simple-gray-50'
              "
              [class.constant]="(section.width ?? theme.section.width) === width.value"
              (click)="section.width = width.value; updateWidth()"
              shape="round"
              height="0-5"
              spacing="1"
            >
              {{ width.label }}
            </button>
          }
        </div>
      </div>
    }

    <div class="section-setting-row">
      <div class="setting-name">Padding</div>
      <div class="setting-value">
        @for (padding of verticalPaddings; track padding) {
          <button
            appButton
            [name]="'section_vertical_padding'"
            [analyticsExtra]="{ vertical_padding: padding.value }"
            location="common-section-settings"
            [color]="
              (section.vertical_padding ?? theme.section.vertical_padding) === padding.value
                ? 'simple-primary-opacity'
                : 'simple-gray-50'
            "
            [class.constant]="(section.vertical_padding ?? theme.section.vertical_padding) === padding.value"
            (click)="section.vertical_padding = padding.value; updateVerticalPadding()"
            shape="round"
            height="0-5"
            spacing="1"
          >
            {{ padding.label }}
          </button>
        }
      </div>
    </div>

    <div class="section-setting-row">
      <div class="setting-name">Color</div>
      <div class="setting-value">
        <div
          #titleColorMenu
          [style.--gallery-background-color]="section.layout_background_color || theme.layout_page.background_color"
        >
          <div
            class="background-selector"
            (click)="colorClick($event)"
            appClickTrack
            name="section-background-color"
            location="common-section-settings"
          >
            <div class="hoverlay"></div>
          </div>
        </div>
      </div>
    </div>
    @if (section.object !== 'text') {
      <div class="section-setting-row">
        <div class="setting-name">Title</div>
        <div class="setting-value">
          <app-switch [small]="true">
            <input
              type="checkbox"
              id="option-show-title"
              [ngModel]="!!section.text_title"
              (ngModelChange)="updateSectionHasTitle($event)"
            />
            <label for="option-show-title" data-test-id="option-show-title"></label>
          </app-switch>
        </div>
      </div>
    }
  </div>
} @else {
  <app-color-selector
    [currentColor]="section.layout_background_color || theme.layout_page.background_color"
    (currentColorChange)="updateLayoutBackgroundColor($event)"
    [gallery]="gallery"
    [allowReset]="true"
  >
  </app-color-selector>
}
